import React, { Component } from 'react';
import { Form, Input, message, Modal, Row, Select } from 'antd';
import { connect } from 'react-redux';

import { queryProtectionInfo, querySaveProtection } from '@api/xxcrm/protect';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    if (this.props.protectUuid) {
      this.loadDetail(this.props.protectUuid);
    }
  }

  /**
   * 获取客户保护详情
   */
  loadDetail = uuid => {
    queryProtectionInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 添加客户保护
   */
  submit = () => {
    const data = this.props.form.getFieldsValue();
    data.name = data.name.replace(/\s+/g, '');
    this.props.form.validateFields(err => {
      if (!err) {
        if (this.props.protectUuid) {
          data.uuid = this.props.protectUuid;
        }
        querySaveProtection(data).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.props.loadDate();
            this.props.cancel();
          } else {
            message.error(res.message);
          }
        });
      }
    });
  };

  handleChange = () => {
    this.props.form.setFieldsValue({
      name: 111,
    });
  };

  render() {
    const { cancel, title } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { data } = this.state;
    return (
      <Modal
        title={title}
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem label="公司名称" {...formItemLayout}>
              {getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: '公司名称不能包含空格！',
                    pattern: /^[^ ]+$/,
                  },
                ],
                initialValue: data.name,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="联系人姓名" {...formItemLayout}>
              {getFieldDecorator('contactName', {
                rules: [{ message: '联系人姓名不能为空！' }],
                initialValue: data.contactName,
              })(<Input placeholder="" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="联系人电话" {...formItemLayout}>
              {getFieldDecorator('phone', {
                rules: [{ message: '联系人电话不能为空！' }],
                initialValue: data.phone,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="联系人手机" {...formItemLayout}>
              {getFieldDecorator('mobile', {
                rules: [
                  {
                    required: true,
                    message: '手机号不合法！',
                    pattern: /^((1[,358]\d)|(14[,57])|(17[,06-8])|(197))\d{8}$/,
                  },
                ],
                initialValue: data.mobile,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="行业" {...formItemLayout}>
              {getFieldDecorator('industry', {
                rules: [{ message: '行业不能为空！' }],
                initialValue: data.industry,
              })(
                <Select>
                  {this.props.list.map(item => {
                    return <Option key={item.value}>{item.key}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="公司网址" {...formItemLayout}>
              {getFieldDecorator('url', {
                rules: [{ message: '基金名称不能为空！' }],
                initialValue: data.url,
              })(<Input placeholder="" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="法人姓名" {...formItemLayout}>
              {getFieldDecorator('legal', {
                rules: [{ message: '基金名称不能为空！' }],
                initialValue: data.legal,
              })(<Input placeholder="" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="公司地址" {...formItemLayout}>
              {getFieldDecorator('area', {
                rules: [{ message: '基金名称不能为空！' }],
                initialValue: data.area,
              })(<Input placeholder="" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="详细地址" {...formItemLayout}>
              {getFieldDecorator('addr', {
                rules: [{ message: '基金名称不能为空！' }],
                initialValue: data.addr,
              })(<Input placeholder="" />)}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({ list: state.industry_list }))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/protect/FormAddCus.js